import { render, staticRenderFns } from "./CompanyProfileAbout.vue?vue&type=template&id=f0c25b3e&scoped=true"
import script from "./CompanyProfileAbout.vue?vue&type=script&lang=js"
export * from "./CompanyProfileAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c25b3e",
  null
  
)

export default component.exports